import { Search, SlidersHorizontal, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import jewmapLogo from "@/assets/jewmap-logo.png";
import { useState, useEffect } from "react";

interface TopBarProps {
  onFilterClick: () => void;
  onSearchClick?: () => void;
}

export const TopBar = ({ onFilterClick, onSearchClick }: TopBarProps) => {
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem('theme') === 'dark';
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className="bg-card/95 backdrop-blur-md rounded-2xl px-4 py-3 flex items-center gap-3 shadow-[0_4px_16px_rgba(0,0,0,0.15)] border border-border/30">
      {/* Logo */}
      <div className="flex items-center gap-2">
        <img src={jewmapLogo} alt="JewMap" width={40} height={40} className="w-10 h-10 object-contain" />
        <span className="font-bold text-xl text-primary hidden lg:block">JewMap</span>
      </div>

      {/* Search Bar */}
      <button
        onClick={onSearchClick}
        className="flex items-center gap-2 px-4 py-2 bg-muted/50 hover:bg-muted rounded-xl border border-border/50 hover:border-primary/30 transition-all min-w-[200px] lg:min-w-[280px]"
      >
        <Search className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm text-muted-foreground flex-1 text-left">Rechercher...</span>
        <kbd className="hidden sm:inline-flex h-5 items-center gap-1 rounded border border-border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
          <span className="text-xs">⌘</span>K
        </kbd>
      </button>

      {/* Actions */}
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={onFilterClick}
          aria-label="Ouvrir les filtres"
          className="h-10 w-10 rounded-full border-border/50 hover:border-primary/50 hover:bg-primary/10"
        >
          <SlidersHorizontal className="w-5 h-5" />
        </Button>

        <Button
          variant="outline"
          size="icon"
          onClick={toggleTheme}
          aria-label={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
          className="h-10 w-10 rounded-full border-border/50 hover:border-primary/50 hover:bg-primary/10"
        >
          {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
        </Button>
      </div>
    </div>
  );
};
